module.exports = __webpack_public_path__ + "static/media/env3@2x.a5050f16.png";